/* CLEARWAKE: Skript der Sektion "Clearwake Produkt Paket" (sections/clearwake-produkt-paket.liquid).
   Liest die JSON-Daten der Sektion ([data-pb-data]) und steuert Paketgroesse, Sorten, Kaufart,
   Abo-Intervalle, Pfand-Zeile, Galerie und den Warenkorb-Aufruf (Paket + Pfand, im Abo mit Verkaufsplan).
   Wunschpaket (data.mixer): Stepper je Sorte (data.mixer.step Dosen). Die Paketgroesse ist immer die
   Summe der Sorten: mehr Dosen = naechstgroesseres Paket, weniger = kleineres. Tipp auf eine Sorten-
   Kachel = sortenrein. Sortenreine Pakete kaufen die Variante des Sortenprodukts, gemischte die
   Variante des Wunschpaket-Produkts mit der Zusammenstellung als Eigenschaft der Warenkorb-Position.
   Pre-Launch (data.prelaunch): Varianten ohne Bestand sehen aus wie verfuegbar, nur der Button ist gesperrt.
   Galerie: ein Bild-Set je Sorte, Probierpaket und Wunschpaket ([data-pb-set]); sichtbar ist nur das Set der
   aktuellen Auswahl, Pfeile und Vorschaubilder blaettern nur darin. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.pbInit === '1') return;
    root.dataset.pbInit = '1';

    /* Aufklapp-Felder: auf- und zuklappen (unabhaengig vom Kaufformular) */
    root.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var accHead = e.target.closest('[data-pb-acc-head]');
      if (!accHead) return;
      var accItem = accHead.closest('[data-pb-acc]');
      if (!accItem) return;
      var on = !accItem.classList.contains('is-open');
      accItem.classList.toggle('is-open', on);
      accHead.setAttribute('aria-expanded', on ? 'true' : 'false');
    });

    /* Bildspalte (Desktop): Ist sie hoeher als das Fenster, haftet sie mit der Unterkante,
       damit die Info-Box unter den Fotos beim Scrollen sichtbar wird. */
    var galleryEl = root.querySelector('[data-pb-gallery]');
    function stick() {
      if (!galleryEl) return;
      galleryEl.style.top = '';
      var h = galleryEl.offsetHeight;
      if (!h) return;
      var t = parseFloat(window.getComputedStyle(galleryEl).top) || 0;
      if (h + t + 24 > window.innerHeight) galleryEl.style.top = (window.innerHeight - h - 24) + 'px';
    }
    stick();
    window.addEventListener('resize', stick);
    window.addEventListener('load', stick);
    if (galleryEl && 'ResizeObserver' in window) { new ResizeObserver(stick).observe(galleryEl); }

    var dataEl = root.querySelector('[data-pb-data]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: data.currency || 'EUR' });
    function money(cents) { return fmt.format(cents / 100); }
    function norm(s) { return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }

    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var planInput = form.querySelector('[name="selling_plan"]');
    var submit = root.querySelector('[data-pb-submit]');
    var submitLabel = root.querySelector('[data-pb-submit-label]');
    var planSelect = root.querySelector('[data-pb-plan]');
    var planRow = root.querySelector('[data-pb-plan-row]');
    var planName = root.querySelector('[data-pb-plan-name]');
    var aboLabel = root.querySelector('[data-pb-abo]');
    var aboRadio = root.querySelector('[data-pb-mode][value="abo"]');
    var onceRadio = root.querySelector('[data-pb-mode][value="once"]');
    var aboBadge = root.querySelector('[data-pb-abo-badge]');
    var aboNa = root.querySelector('[data-pb-abo-na]');
    var hasPlans = data.plans.length > 0;
    var ship = data.ship || { cost: 0, free: 0, aboFree: true };
    /* Pre-Launch: Varianten ohne Bestand werden wie verfuegbar gezeigt (Preise, Kacheln, Abo),
       nur der Button ist gesperrt und zeigt data.t.prelaunch */
    var pre = !!data.prelaunch;
    function avail(v) { return !!(v && (v.a || pre)); }

    function checked(sel) { var el = root.querySelector(sel + ':checked'); return el ? el.value : null; }
    function checkedEl(sel) { return root.querySelector(sel + ':checked'); }

    /* ---------- Wunschpaket: Dosen je Sorte, Paketgroessen, Varianten je Sorte ---------- */
    var mixer = data.mixer || null;
    var counts = {};
    var sizes = [];
    var lead = null;
    if (mixer) {
      var raw = (mixer.sizes && mixer.sizes.length) ? mixer.sizes : [];
      if (!raw.length) { for (var mv = 0; mv < mixer.variants.length; mv++) raw.push(mixer.variants[mv].cans); }
      for (var rs = 0; rs < raw.length; rs++) { var n0 = parseInt(raw[rs], 10); if (n0 > 0 && sizes.indexOf(n0) < 0) sizes.push(n0); }
      sizes.sort(function (a, b) { return a - b; });
      if (!sizes.length || !mixer.flavours || !mixer.flavours.length || !(mixer.step > 0)) mixer = null;
    }
    if (mixer) {
      lead = mixer.pageFlavour || null;
      if (lead && !flavourObj(lead)) lead = null;
    }
    var minSize = sizes.length ? sizes[0] : 0;
    var maxSize = sizes.length ? sizes[sizes.length - 1] : 0;

    function flavourObj(name) {
      for (var i = 0; mixer && i < mixer.flavours.length; i++) { if (mixer.flavours[i].name === name) return mixer.flavours[i]; }
      return null;
    }
    function flavourNames() { var out = []; for (var i = 0; mixer && i < mixer.flavours.length; i++) out.push(mixer.flavours[i].name); return out; }
    function mixTotal() { var t = 0; for (var k in counts) { if (counts.hasOwnProperty(k)) t += counts[k]; } return t; }
    /* Genau eine Sorte gewaehlt -> ihr Name, sonst null */
    function singleFlavour() {
      var one = null, n = 0;
      for (var k in counts) { if (counts.hasOwnProperty(k) && counts[k] > 0) { n++; one = k; } }
      return n === 1 ? one : null;
    }
    /* Variante des Sortenprodukts zur Dosenzahl */
    function flavourVariant(name, cans) {
      var f = flavourObj(name);
      if (!f) return null;
      for (var i = 0; i < f.variants.length; i++) { if (f.variants[i].cans === cans) return f.variants[i]; }
      return null;
    }
    /* Variante des Wunschpaket-Produkts zur Dosenzahl */
    function mixerVariant(cans) {
      for (var i = 0; mixer && i < mixer.variants.length; i++) { if (mixer.variants[i].cans === cans) return mixer.variants[i]; }
      return null;
    }
    /* Abo-Variante (Sorte x Paket) aus dem Abo-Produkt; null, wenn es keine gibt */
    function resolveAbo(flavour, cans) {
      if (!data.abo) return null;
      var name = flavour !== null ? flavour : data.flavourName;
      for (var i = 0; i < data.abo.variants.length; i++) {
        var v = data.abo.variants[i];
        if (data.abo.fi >= 0 && norm(v.o[data.abo.fi]) !== norm(name)) continue;
        if (parseInt(v.o[data.abo.pi], 10) !== cans) continue;
        return v;
      }
      return null;
    }
    /* Abo-Variante des Wunschpakets (Sorte "Wunschpaket" im Abo-Produkt) */
    function resolveAboMixer(cans) {
      if (!mixer || !data.abo || data.abo.fi < 0) return null;
      return resolveAbo(mixer.aboName, cans);
    }
    function isAboMixer(av) { return !!(av && mixer && data.abo && data.abo.fi >= 0 && norm(av.o[data.abo.fi]) === norm(mixer.aboName)); }
    /* Vorausgewaehltes Intervall je Paketgroesse ("24=alle 4 Wochen; 36=alle 6 Wochen") */
    function mixerPlanDefault(total) {
      var s = String((mixer && mixer.planDefaults) || '');
      var parts = s.split(';');
      for (var i = 0; i < parts.length; i++) {
        var kv = parts[i].split('=');
        if (kv.length === 2 && parseInt(kv[0], 10) === total) return kv[1].trim();
      }
      return '';
    }
    function sizesText() {
      var s = sizes.slice();
      if (s.length < 2) return String(s[0] || '');
      var last = s.pop();
      return s.join(', ') + ' oder ' + last;
    }
    /* Zusammenstellung als Text ("12 × Grapefruit · 24 × Zitrone-Minze"), Reihenfolge wie die Sorten-Bloecke */
    function mixText() {
      var parts = [], names = flavourNames();
      for (var i = 0; i < names.length; i++) { if (counts[names[i]] > 0) parts.push(counts[names[i]] + ' × ' + names[i]); }
      return parts.join(' · ');
    }
    /* Startwerte: ?mix=12,12,0 (Reihenfolge der Sorten-Bloecke), sonst Sorte der Seite = ganze Paketgroesse,
       sonst gleichmaessig verteilt */
    function mixInit(preCans) {
      if (!mixer) return;
      var names = flavourNames(), sum = 0, i;
      for (i = 0; i < names.length; i++) counts[names[i]] = 0;
      var m = window.location.search.match(/[?&]mix=([\d,]+)/);
      if (m) {
        var vals = m[1].split(',');
        for (i = 0; i < names.length && i < vals.length; i++) {
          var n = Math.round((parseInt(vals[i], 10) || 0) / mixer.step) * mixer.step;
          if (n > 0 && sum + n <= maxSize) { counts[names[i]] = n; sum += n; }
        }
        if (sum >= minSize) return;
        for (i = 0; i < names.length; i++) counts[names[i]] = 0;
      }
      var size = preCans;
      if (sizes.indexOf(size) < 0) size = sizes[Math.floor((sizes.length - 1) / 2)];
      if (lead) { counts[lead] = size; return; }
      var share = Math.floor(size / names.length / mixer.step) * mixer.step;
      for (i = 0; i < names.length; i++) { if (sum + share <= size) { counts[names[i]] = share; sum += share; } }
      /* Rest (z. B. 24 Dosen auf drei Sorten) auf die ersten Sorten verteilen */
      for (i = 0; sum < size && i < names.length; i++) { counts[names[i]] += mixer.step; sum += mixer.step; }
    }
    /* Groesste Sorte (ohne "skip"); bei Gleichstand die erste (fromEnd=false) oder letzte (fromEnd=true) */
    function largest(skip, fromEnd) {
      var names = flavourNames(), best = null, bestN = 0;
      for (var i = 0; i < names.length; i++) {
        if (names[i] === skip) continue;
        var n = counts[names[i]] || 0;
        if (n > bestN || (n === bestN && n > 0 && fromEnd)) { best = names[i]; bestN = n; }
      }
      return bestN > 0 ? best : null;
    }
    /* Eine Sorte um einen Schritt aendern. Mehr: bis zur groessten Paketgroesse. Weniger: unter die kleinste
       Paketgroesse geht es nicht - dann wandert der Schritt zur groessten anderen Sorte. */
    function mixAdjust(name, dir) {
      if (!mixer || !(name in counts)) return false;
      var step = mixer.step, total = mixTotal();
      if (dir > 0) {
        if (total + step > maxSize) return false;
        counts[name] += step;
        return true;
      }
      if (counts[name] <= 0) return false;
      if (total - step < minSize) {
        var other = largest(name, false);
        if (!other) return false;
        counts[name] -= step;
        counts[other] += step;
        return true;
      }
      counts[name] -= step;
      return true;
    }
    /* Sortenrein: alle Dosen der aktuellen Paketgroesse auf diese Sorte */
    function mixSolo(name) {
      if (!mixer || !(name in counts)) return false;
      var total = mixTotal();
      if (total < minSize) total = minSize;
      if (counts[name] === total) return false;
      var names = flavourNames();
      for (var i = 0; i < names.length; i++) counts[names[i]] = 0;
      counts[name] = total;
      return true;
    }
    /* Paketgroesse per Kachel: Mehr Dosen gehen an die Sorte der Seite (sonst die groesste),
       weniger werden bei den anderen Sorten abgezogen (zuletzt bei der Sorte der Seite). */
    function mixResize(size) {
      if (!mixer) return false;
      var total = mixTotal(), step = mixer.step;
      if (size === total) return false;
      var i, names = flavourNames();
      if (size > total) {
        var to = (lead && lead in counts) ? lead : (largest(null, false) || names[0]);
        counts[to] += size - total;
        return true;
      }
      var guard = 0;
      while (total > size && guard++ < 100) {
        var from = largest(lead, true);
        if (!from) from = largest(null, true);
        if (!from) break;
        var take = Math.min(step, counts[from], total - size);
        counts[from] -= take;
        total -= take;
      }
      return true;
    }
    /* Kachel der Paketgroesse zur Summe markieren */
    function syncSize() {
      if (!mixer) return;
      var total = mixTotal();
      var radios = root.querySelectorAll('[data-pb-pack]:not([data-pb-mix])');
      var hit = false;
      for (var i = 0; i < radios.length; i++) {
        var on = parseInt(radios[i].value, 10) === total;
        radios[i].checked = on;
        if (on) hit = true;
      }
      return hit;
    }

    /* Variante, Stueckzahl und Dosenzahl fuer die Zusammenstellung (Wunschpaket) */
    function resolveComp(total, single) {
      if (single) {
        var fv = flavourVariant(single, total);
        if (fv) return { v: fv, q: 1, cans: total, flavour: single, single: true, cfg: false, mix: false };
      }
      var cv = mixerVariant(total);
      return { v: cv, q: 1, cans: total, flavour: single, single: !!single, cfg: true, mix: false };
    }
    /* Variante und Stueckzahl fuer Sorte + Dosenzahl (ohne Wunschpaket) */
    function resolveClassic(flavour, cans) {
      var exact = null, base = null;
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        if (data.fi >= 0 && flavour !== null && v.o[data.fi] !== flavour) continue;
        if (data.pi >= 0) {
          var n = parseInt(v.o[data.pi], 10);
          if (n === cans) exact = exact || v;
          if (n === 1) base = base || v;
        } else {
          base = base || v;
        }
      }
      if (exact) return { v: exact, q: 1, cans: cans, flavour: flavour, single: true, cfg: false, mix: false };
      if (base) return { v: base, q: cans, cans: cans, flavour: flavour, single: true, cfg: false, mix: false };
      return null;
    }
    function resolveMix() {
      if (!data.mix) return null;
      return { v: data.mix, q: 1, cans: data.mix.cans, flavour: null, single: false, cfg: false, mix: true };
    }

    /* Pfand-Variante fuer die Dosenzahl: die passende Paket-Variante (z. B. "24 Dosen", Menge 1),
       sonst die Einzel-Variante ("1 Dose") in Dosenzahl-Menge. */
    function pfandFor(cans) {
      if (!data.pfand || !data.pfand.length) return null;
      var single = null;
      for (var i = 0; i < data.pfand.length; i++) {
        if (data.pfand[i].cans === cans && avail(data.pfand[i])) return { v: data.pfand[i], q: 1 };
        if (data.pfand[i].cans === 1) single = data.pfand[i];
      }
      if (single && avail(single)) return { v: single, q: cans };
      return null;
    }

    /* Intervall-Laenge in Tagen aus dem Plannamen ("alle 6 Wochen" -> 42), fuer die Sortierung */
    function planDays(plan) {
      var s = String(plan.name || '');
      var m = s.match(/(\d+)\s*(tag|woche|monat|day|week|month)/i);
      if (!m) { var n = s.match(/\d+/); return n ? parseInt(n[0], 10) : 0; }
      var n2 = parseInt(m[1], 10), u = m[2].toLowerCase();
      if (u.indexOf('woche') === 0 || u.indexOf('week') === 0) return n2 * 7;
      if (u.indexOf('monat') === 0 || u.indexOf('month') === 0) return n2 * 30;
      return n2;
    }
    /* Verkaufsplaene, die es fuer diese Variante gibt, aufsteigend nach Intervall */
    function plansFor(v) {
      var out = [];
      for (var i = 0; i < data.plans.length; i++) {
        if (v && v.sp && v.sp[data.plans[i].id] != null) out.push(data.plans[i]);
      }
      out.sort(function (a, b) { return planDays(a) - planDays(b); });
      return out;
    }
    function planText(plan) {
      var s = String(plan.name || '').split(',')[0];
      if (data.t.planStrip) s = s.replace(data.t.planStrip, '');
      return s.trim();
    }

    /* Kaufart, die der Kunde selbst angeklickt hat ('abo' oder 'once'); leer = noch keine Wahl.
       Solange sie nicht 'once' ist, wird das Abo bei jedem Paket mit Abo vorausgewaehlt. */
    var chosenMode = '';
    /* Gewaehlter Plan fuer die Variante: Intervall, das der Nutzer angeklickt hat (auch beim
       Paketwechsel), sonst die Vorauswahl (Einstellung je Groesse, Block), sonst der kuerzeste */
    var chosenText = '';
    function planFor(v, defaultText) {
      var list = plansFor(v);
      if (!list.length) return null;
      var i;
      if (chosenText) { for (i = 0; i < list.length; i++) { if (norm(planText(list[i])) === chosenText) return list[i]; } }
      var d = norm(defaultText);
      if (d) { for (i = 0; i < list.length; i++) { if (norm(planText(list[i])).indexOf(d) >= 0) return list[i]; } }
      return list[0];
    }
    function planDefaultFor(cans, tileDefault) {
      var d = mixer ? mixerPlanDefault(cans) : '';
      return d || tileDefault || '';
    }

    /* Preise fuer eine aufgeloeste Auswahl: Einmalpreis, Abo-Preis, Plan, Abo-Variante */
    function prices(r, defaultText) {
      if (!r) return null;
      var once = r.v ? r.v.p * r.q : null;
      var abo = null, plan = null, av = null;
      if (r.mix) return { r: r, once: once, abo: null, plan: null, av: null };
      if (data.abo) {
        /* Abo-Preis und -Plaene kommen aus dem Abo-Produkt: Sorte x Paket, gemischt ueber die Sorte "Wunschpaket" */
        if (r.single && r.flavour !== null) av = resolveAbo(r.flavour, r.cans);
        if (!av && (r.cfg || mixer)) av = resolveAboMixer(r.cans);
        if (!av && !mixer) av = resolveAbo(r.flavour, r.cans);
        plan = av ? planFor(av, defaultText) : null;
        if (plan) abo = av.sp[plan.id];
      } else if (r.v) {
        plan = planFor(r.v, defaultText);
        if (plan) {
          abo = r.v.sp[plan.id] * r.q;
        } else if (!hasPlans && data.preview > 0) {
          abo = Math.round(once * (100 - data.preview) / 100);
        }
      }
      if (!r.v && once === null) { abo = null; plan = null; }
      return { r: r, once: once, abo: abo, plan: plan, av: av };
    }

    function perCan(total, cans) { return money(Math.round(total / cans)) + ' / ' + data.t.unit; }
    /* Versandkosten fuer einen Paketpreis in der Kaufart (0 = frei) */
    function shipFor(price, mode) {
      if (!ship.cost || price === null) return 0;
      if (mode === 'abo' && ship.aboFree) return 0;
      if (ship.free > 0 && price >= ship.free) return 0;
      return ship.cost;
    }
    function shipLine(price, mode) {
      if (!ship.cost || price === null) return '';
      var c = shipFor(price, mode);
      return c > 0 ? String(data.t.shipPlus || '').replace('[betrag]', money(c)) : String(data.t.shipFree || '');
    }
    /* Versandzeile in eine Kachel schreiben. "Versandkostenfrei" bekommt eine Kurzfassung fuers Handy
       (data.t.shipFreeShort, z. B. "Versandfrei"); welche sichtbar ist, entscheidet das CSS. */
    function setShip(el, price, mode) {
      if (!el) return;
      var text = shipLine(price, mode);
      var short = String(data.t.shipFreeShort || '');
      if (text && text === String(data.t.shipFree || '') && short && short !== text) {
        el.textContent = '';
        var a = document.createElement('span');
        a.className = 'cw-pb__ship-long';
        a.textContent = text;
        var b = document.createElement('span');
        b.className = 'cw-pb__ship-short';
        b.textContent = short;
        el.appendChild(a);
        el.appendChild(b);
      } else {
        el.textContent = text;
      }
    }

    /* Wunschpaket: Stepper, Markierungen "× 12", Summenzeile und Hinweis */
    function renderMixer(isMix, cur) {
      var box = root.querySelector('[data-pb-mixer]');
      if (!mixer) { if (box) box.hidden = true; return; }
      var total = mixTotal();
      var wraps = root.querySelectorAll('[data-pb-flavour-wrap]');
      /* Probierpaket gewaehlt: Stepper zeigen die feste Verteilung (z. B. 12 Dosen / 3 Sorten = 4),
         die eigene Zusammenstellung bleibt im Hintergrund erhalten */
      var mixEach = (isMix && data.mix && data.mix.cans && mixer.flavours.length) ? Math.round(data.mix.cans / mixer.flavours.length) : null;
      for (var i = 0; i < wraps.length; i++) {
        var f = wraps[i].getAttribute('data-flavour');
        var n = counts[f] || 0;
        wraps[i].classList.toggle('is-picked', !isMix && n > 0);
        var val = wraps[i].querySelector('[data-pb-step-val]');
        if (val) val.textContent = String(mixEach !== null ? mixEach : n);
        var badge = wraps[i].querySelector('[data-pb-flavour-n]');
        if (badge) badge.textContent = (!isMix && n > 0) ? '× ' + n : '';
        var minus = wraps[i].querySelector('[data-pb-step="-1"]');
        var plus = wraps[i].querySelector('[data-pb-step="1"]');
        if (minus) minus.disabled = isMix || n <= 0 || (total - mixer.step < minSize && !largest(f, false));
        if (plus) plus.disabled = isMix || total + mixer.step > maxSize;
      }
      if (!box) return;
      box.hidden = isMix;
      if (isMix) return;
      var totalEl = box.querySelector('[data-pb-mixer-total]');
      var listEl = box.querySelector('[data-pb-mixer-list]');
      var hintEl = box.querySelector('[data-pb-mixer-hint]');
      if (totalEl) totalEl.textContent = String(data.t.mixerTotal || '[dosen]').replace('[dosen]', String(total));
      if (listEl) listEl.textContent = mixText();
      if (hintEl) {
        var ok = !!(cur && cur.r && cur.r.v && cur.once !== null);
        var hint = '', warn = false;
        if (!ok) { warn = true; hint = String(data.t.mixerSizes || '').replace('[groessen]', sizesText()); }
        else if (total >= maxSize) hint = String(data.t.mixerMax || '').replace('[max]', String(maxSize));
        else if (total <= minSize) hint = String(data.t.mixerMin || '').replace('[min]', String(minSize));
        hintEl.textContent = hint;
        hintEl.hidden = !hint;
        hintEl.classList.toggle('is-warn', warn);
      }
    }

    function update() {
      var packEl = checkedEl('[data-pb-pack]');
      var isMix = !!(packEl && packEl.hasAttribute('data-pb-mix'));
      var tileDefault = packEl ? packEl.getAttribute('data-pb-plan-default') : '';
      var flavour = data.fi >= 0 ? checked('[data-pb-flavour]') : null;
      var r, single = null, total = 0;
      if (isMix) {
        r = resolveMix();
      } else if (mixer) {
        total = mixTotal();
        single = singleFlavour();
        r = resolveComp(total, single);
      } else {
        var cans = parseInt(packEl ? packEl.value : '1', 10);
        r = resolveClassic(flavour, cans);
      }
      var cur = prices(r, planDefaultFor(r ? r.cans : 0, tileDefault));
      /* Wunschpaket ohne passende Variante: Summe passt zu keiner Paketgroesse */
      var cfgInvalid = !!(mixer && !isMix && (!cur || !cur.r.v || cur.once === null));

      /* Abo nur, wenn die gewaehlte Variante einen Verkaufsplan hat (Vorschau-Rabatt zaehlt nicht) und das
         Paket selbst Bestand hat: das Abo-Produkt verkauft dieselben Dosen, also kein Abo fuer ein leeres Paket */
      var aboOk = !!(hasPlans && cur && cur.plan && cur.abo !== null && avail(cur.r.v));
      if (aboRadio) {
        aboRadio.disabled = !aboOk;
        if (aboLabel) aboLabel.classList.toggle('is-disabled', !aboOk);
        if (!aboOk && aboRadio.checked && onceRadio) { onceRadio.checked = true; }
        /* Abo ist die Vorauswahl: bei jedem Paket mit Abo wieder einschalten, auch nach dem Probierpaket.
           Nur wenn der Kunde selbst Einmalkauf angeklickt hat, bleibt seine Wahl. */
        if (aboOk && chosenMode !== 'once' && !aboRadio.checked) { aboRadio.checked = true; }
        if (aboBadge) aboBadge.hidden = !aboOk;
        if (aboNa) aboNa.hidden = aboOk || cfgInvalid;
      }
      var mode = checked('[data-pb-mode]') || 'once';
      var isMixed = !!(mixer && !isMix && !single);
      root.classList.toggle('is-mix', isMix);
      root.classList.toggle('is-mixed', isMixed);
      root.classList.toggle('is-abo', mode === 'abo');

      /* Kacheln der Paketgroesse: Preis, je Dose und Versand in der gewaehlten Kaufart */
      var packs = root.querySelectorAll('[data-pb-pack]');
      for (var i = 0; i < packs.length; i++) {
        var c = parseInt(packs[i].value, 10);
        var pm = packs[i].hasAttribute('data-pb-mix');
        var label = packs[i].closest('.cw-pb__pack');
        var sub = label.querySelector('[data-pb-pack-sub]');
        var priceEl = label.querySelector('[data-pb-pack-price]');
        var shipEl = label.querySelector('[data-pb-pack-ship]');
        var pr = pm ? resolveMix() : (mixer ? resolveComp(c, single) : resolveClassic(flavour, c));
        var p = prices(pr, planDefaultFor(c, packs[i].getAttribute('data-pb-plan-default')));
        var ok = !!(p && p.r.v && avail(p.r.v) && p.once !== null);
        label.classList.toggle('is-unavailable', !ok);
        if (!ok) { if (sub) sub.textContent = ''; if (priceEl) priceEl.textContent = ''; if (shipEl) shipEl.textContent = ''; continue; }
        var useAboHere = mode === 'abo' && p.abo !== null;
        var tot = useAboHere ? p.abo : p.once;
        if (pm) {
          /* Probierpaket-Zeile: Preis und je Dose (kein Abo) */
          if (sub) sub.textContent = (mode === 'abo' && hasPlans && data.t.onceOnly ? data.t.onceOnly + ' · ' : '') + money(p.once) + ' · ' + perCan(p.once, p.r.cans);
          setShip(shipEl, p.once, 'once');
          continue;
        }
        if (priceEl) priceEl.textContent = money(tot);
        /* je Dose + Zusatz ("im Abo"); der Zusatz steht in eigenem Span, damit er auf dem Handy sauber in Zeile 2 rutscht */
        if (sub) {
          sub.textContent = perCan(tot, p.r.cans);
          var extra = useAboHere ? ' ' + data.t.abo : (mode === 'abo' && hasPlans ? ' · ' + data.t.onceOnly : '');
          if (extra.trim()) {
            var ex = document.createElement('span');
            ex.className = 'cw-pb__pack-sub-x';
            ex.textContent = extra;
            sub.appendChild(ex);
          }
        }
        setShip(shipEl, tot, useAboHere ? 'abo' : 'once');
      }
      /* Kacheln, die nur verlinken (Probierpaket-Seite ohne Wunschpaket): Preis je Dose */
      var links = root.querySelectorAll('[data-pb-pack-link]');
      for (var l = 0; l < links.length; l++) {
        var lp = parseInt(links[l].getAttribute('data-pb-price'), 10);
        var lc = parseInt(links[l].getAttribute('data-pb-cans'), 10);
        var ls = links[l].querySelector('[data-pb-pack-sub]');
        if (ls && lp && lc) ls.textContent = perCan(lp, lc);
      }

      /* Titel, Geschmackstext und Sortenfarbe */
      var suffix = root.querySelector('[data-pb-title-suffix]');
      var taste = root.querySelector('[data-pb-taste]');
      var fo = (mixer && single) ? flavourObj(single) : null;
      if (suffix) {
        suffix.textContent = isMix ? (suffix.getAttribute('data-mix') || '')
          : isMixed ? (mixer.name || suffix.getAttribute('data-mixer') || '')
          : fo ? fo.name : (suffix.getAttribute('data-flavour') || '');
      }
      if (taste) {
        var tt = isMix ? (taste.getAttribute('data-mix') || '')
          : isMixed ? (mixer.taste || taste.getAttribute('data-mixer') || '')
          : fo ? (fo.taste || '') : (taste.getAttribute('data-flavour') || '');
        taste.textContent = tt;
        taste.hidden = !tt;
      }
      if (mixer) {
        var accent = fo && fo.color ? fo.color : (mixer.pageFlavour && flavourObj(mixer.pageFlavour) ? flavourObj(mixer.pageFlavour).color : '');
        if (accent) root.style.setProperty('--pb-accent', accent);
      }
      var flavoursEl = root.querySelector('[data-pb-flavours]');
      if (flavoursEl) flavoursEl.classList.toggle('is-mix', isMix);
      renderMixer(isMix, cur);
      var nameEls = root.querySelectorAll('[data-pb-flavour-name]');
      for (var ne = 0; ne < nameEls.length; ne++) { if (flavour !== null) nameEls[ne].textContent = flavour; }

      var oncePrice = root.querySelector('[data-pb-once-price]');
      var onceUnit = root.querySelector('[data-pb-once-unit]');
      var aboPrice = root.querySelector('[data-pb-abo-price]');
      var aboUnit = root.querySelector('[data-pb-abo-unit]');
      var aboSave = root.querySelector('[data-pb-abo-save]');
      var base = root.querySelector('[data-pb-base]');

      /* Pfandbetrag des gewaehlten Pakets (getrennt vom Preis) */
      var pfandEl = root.querySelector('[data-pb-pfand]');
      if (pfandEl) {
        var pfc = (cur && !cfgInvalid && cur.r.cans > 0) ? pfandFor(cur.r.cans) : null;
        pfandEl.textContent = (pfc && data.t.pfand) ? data.t.pfand.replace('[betrag]', money(pfc.v.p * pfc.q * cur.r.q)).replace('[je]', money(Math.round(pfc.v.p * pfc.q / cur.r.cans))) : '';
      }

      if (!cur || cfgInvalid) {
        update.sel = null;
        submit.disabled = true;
        if (cfgInvalid) {
          submitLabel.textContent = String(data.t.mixerSizes || '').replace('[groessen]', sizesText());
          var clear = root.querySelectorAll('[data-pb-once-price], [data-pb-once-unit], [data-pb-abo-price], [data-pb-abo-unit], [data-pb-abo-save], [data-pb-base]');
          for (var ce = 0; ce < clear.length; ce++) clear[ce].textContent = '';
          if (planRow) planRow.hidden = true;
          if (planName) planName.hidden = true;
        } else {
          submitLabel.textContent = data.t.soldout;
        }
        return;
      }

      oncePrice.textContent = money(cur.once);
      onceUnit.textContent = perCan(cur.once, cur.r.cans);
      if (cur.abo !== null) {
        aboPrice.textContent = money(cur.abo);
        aboUnit.textContent = perCan(cur.abo, cur.r.cans);
        /* Ersparnis je Lieferung: Preisunterschied plus gesparter Versand */
        var shipDiff = shipFor(cur.once, 'once') - shipFor(cur.abo, 'abo');
        var saving = cur.once - cur.abo + shipDiff;
        if (saving > 0) {
          aboSave.textContent = (shipDiff > 0 && data.t.saveShip)
            ? String(data.t.saveShip).replace('[betrag]', money(saving)).replace('[versand]', money(shipDiff))
            : String(data.t.save || '').replace('[betrag]', money(saving));
        } else {
          aboSave.textContent = '';
        }
      } else {
        aboPrice.textContent = '';
        aboUnit.textContent = '';
        aboSave.textContent = '';
      }

      /* Intervall: Chips nur bei mehreren Plaenen je Variante, sonst eine Textzeile */
      if (hasPlans) {
        var list = plansFor(cur.av || cur.r.v);
        var chips = root.querySelectorAll('[data-pb-plan-chip]');
        for (var ci = 0; ci < chips.length; ci++) {
          var cid = chips[ci].getAttribute('data-pb-plan-chip');
          var inList = false;
          for (var li = 0; li < list.length; li++) { if (String(list[li].id) === cid) inList = true; }
          chips[ci].hidden = !inList;
          var active = !!(cur.plan && String(cur.plan.id) === cid);
          chips[ci].classList.toggle('is-active', active);
          chips[ci].setAttribute('aria-checked', active ? 'true' : 'false');
        }
        if (planRow) planRow.hidden = list.length < 2;
        if (planName) {
          var pt = (cur.plan && list.length < 2) ? planText(cur.plan) : '';
          if (pt && data.t.planLine) pt = data.t.planLine.indexOf('[intervall]') >= 0 ? data.t.planLine.replace('[intervall]', pt) : data.t.planLine + ' ' + pt;
          planName.textContent = pt;
          planName.hidden = !pt;
        }
        if (planSelect && cur.plan) planSelect.value = String(cur.plan.id);
      }

      var useAbo = mode === 'abo' && aboOk;
      var total2 = useAbo ? cur.abo : cur.once;
      /* Im Abo wird die Variante des Abo-Produkts gekauft (fester Abo-Preis), sonst die des Sorten-/Wunschpaket-Produkts */
      var buyV = (useAbo && cur.av) ? cur.av : cur.r.v;
      var buyQ = (useAbo && cur.av) ? 1 : cur.r.q;
      idInput.value = buyV.id;
      qtyInput.value = buyQ;
      if (useAbo && cur.plan) { planInput.disabled = false; planInput.value = String(cur.plan.id); } else { planInput.disabled = true; planInput.value = ''; }
      /* Zusammenstellung als Eigenschaft, wenn die gekaufte Variante zum Wunschpaket gehoert */
      var props = null;
      var buyIsCfg = useAbo && cur.av ? isAboMixer(cur.av) : !!cur.r.cfg;
      if (mixer && buyIsCfg) { props = {}; props[mixer.property || 'Zusammenstellung'] = mixText(); }
      update.sel = { id: buyV.id, q: buyQ, plan: (useAbo && cur.plan) ? String(cur.plan.id) : '', cans: cur.r.cans, props: props };

      var available = avail(buyV);
      /* Pre-Launch: Button gesperrt, Text aus der Einstellung ([preis] = Preis der Auswahl) */
      submit.disabled = !available || pre;
      submitLabel.textContent = pre ? String(data.t.prelaunch || '').replace('[preis]', money(total2))
        : available ? data.t.add + ' · ' + money(total2) : data.t.soldout;

      if (base) {
        var litres = cur.r.cans * data.ml / 1000;
        base.textContent = money(total2) + ' (' + money(Math.round(total2 / litres)) + ' / l).';
      }

      /* Bilder: Probierpaket -> Set "mix", gemischt -> Set "mixer" (ohne eigene Bilder "mix"), eine Sorte ->
         Set "f:Sorte" mit allen Bildern dieser Sorte, sonst das Set der Seite. Ein neues Set beginnt beim
         ersten Bild; hat die Variante ein eigenes Bild im Set, springt die Galerie dorthin. */
      var setKey = pageSet;
      if (isMix) setKey = 'mix';
      else if (mixer && isMixed) setKey = hasSet('mixer') ? 'mixer' : 'mix';
      else if (mixer && single) setKey = 'f:' + single;
      var setChanged = showSet(setKey);
      var vm = (!isMix && !isMixed && cur.r.v && cur.r.v.m) ? String(cur.r.v.m) : '';
      var vSlide = null;
      for (var vi = 0; vm && vi < slides.length; vi++) { if (slides[vi].getAttribute('data-media-id') === vm) { vSlide = slides[vi]; break; } }
      if (vSlide && (setChanged || update.lastMedia !== vm)) goTo(indexOf(vSlide));
      update.lastMedia = vm;
    }

    /* Galerie: Bild-Sets ([data-pb-set]) je Sorte ("f:Grapefruit"), Probierpaket ("mix") und Wunschpaket
       ("mixer"). Sichtbar ist nur das Set der Auswahl; Pfeile und Vorschaubilder blaettern nur darin. */
    var slidesEl = root.querySelector('[data-pb-slides]');
    var thumbsEl = root.querySelector('[data-pb-thumbs]');
    var arrows = root.querySelectorAll('[data-pb-prev], [data-pb-next]');
    var allSlides = root.querySelectorAll('[data-pb-slide]');
    var allThumbs = root.querySelectorAll('[data-pb-thumb]');
    var pageSet = root.getAttribute('data-pb-page-set') || '';
    var curSet = null;
    var slides = [];
    var thumbs = [];
    function setOf(el) { return el.getAttribute('data-pb-set') || ''; }
    function hasSet(key) {
      for (var i = 0; i < allSlides.length; i++) { if (setOf(allSlides[i]) === key) return true; }
      return false;
    }
    /* Set einblenden (unbekanntes Set -> Set der Seite); true, wenn sich das Set geaendert hat */
    function showSet(key) {
      if (!hasSet(key)) key = hasSet(pageSet) ? pageSet : (allSlides.length ? setOf(allSlides[0]) : '');
      if (key === curSet) return false;
      curSet = key;
      slides = [];
      thumbs = [];
      var i;
      for (i = 0; i < allSlides.length; i++) {
        var on = setOf(allSlides[i]) === key;
        allSlides[i].hidden = !on;
        if (on) slides.push(allSlides[i]);
      }
      for (i = 0; i < allThumbs.length; i++) {
        var onT = setOf(allThumbs[i]) === key;
        allThumbs[i].hidden = !onT;
        if (onT) thumbs.push(allThumbs[i]);
      }
      var many = slides.length > 1;
      if (thumbsEl) { thumbsEl.hidden = !many; thumbsEl.scrollLeft = 0; }
      for (i = 0; i < arrows.length; i++) arrows[i].hidden = !many;
      if (slidesEl) slidesEl.scrollLeft = 0;
      mark(0);
      return true;
    }
    function indexOf(el) { for (var i = 0; i < slides.length; i++) { if (slides[i] === el) return i; } return 0; }
    function activeIndex() { return slidesEl ? Math.round(slidesEl.scrollLeft / (slidesEl.clientWidth || 1)) : 0; }
    function mark(i) { for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.toggle('is-active', t === i); }
    function goTo(i) {
      if (!slidesEl || !slides.length) return;
      i = (i + slides.length) % slides.length;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      slidesEl.scrollTo({ left: i * slidesEl.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      mark(i);
    }
    if (slidesEl) {
      var ticking = false;
      slidesEl.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; mark(activeIndex()); });
      }, { passive: true });
    }
    showSet(root.getAttribute('data-pb-init-set') || pageSet);

    root.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-pb-prev]')) { goTo(activeIndex() - 1); return; }
      if (e.target.closest('[data-pb-next]')) { goTo(activeIndex() + 1); return; }
      /* Wunschpaket: Stepper (+/-) je Sorte, die Summe bestimmt die Paketgroesse */
      var step = e.target.closest('[data-pb-step]');
      if (step) {
        e.preventDefault();
        if (step.disabled) return;
        if (mixAdjust(step.getAttribute('data-flavour'), parseInt(step.getAttribute('data-pb-step'), 10) || 0)) { syncSize(); update(); }
        return;
      }
      /* Tipp auf die Sorten-Kachel = sortenrein (statt Seitenwechsel); vom Probierpaket aus zurueck zur Paketgroesse */
      var fl = e.target.closest('[data-pb-flavour-link]');
      if (fl && mixer) {
        e.preventDefault();
        var wasMix = root.classList.contains('is-mix');
        var changed = mixSolo(fl.getAttribute('data-flavour'));
        if (wasMix || changed) { syncSize(); update(); }
        return;
      }
      var chip = e.target.closest('[data-pb-plan-chip]');
      if (chip) {
        chosenText = norm(chip.textContent);
        if (planSelect) planSelect.value = chip.getAttribute('data-pb-plan-chip');
        if (aboRadio && !aboRadio.disabled) { aboRadio.checked = true; chosenMode = 'abo'; }
        update();
        return;
      }
      var th = e.target.closest('[data-pb-thumb]');
      if (th) { for (var i = 0; i < thumbs.length; i++) { if (thumbs[i] === th) goTo(i); } }
    });
    root.addEventListener('change', function (e) {
      if (!e.target.matches) return;
      /* Kaufart vom Kunden angeklickt: merken, damit die Abo-Vorauswahl seine Wahl nicht ueberschreibt */
      if (e.target.matches('[data-pb-mode]')) chosenMode = e.target.value;
      /* Kachel der Paketgroesse: Sorten auffuellen oder abziehen */
      if (mixer && e.target.matches('[data-pb-pack]') && !e.target.hasAttribute('data-pb-mix')) {
        mixResize(parseInt(e.target.value, 10) || 0);
        syncSize();
      }
      if (e.target.matches('[data-pb-flavour], [data-pb-pack], [data-pb-mode], [data-pb-plan]')) update();
    });

    /* Chips aufsteigend nach Intervall sortieren (Reihenfolge in der Abo-App ist egal) */
    var chipsEl = root.querySelector('[data-pb-chips]');
    if (chipsEl) {
      var byId = {};
      for (var pi = 0; pi < data.plans.length; pi++) byId[String(data.plans[pi].id)] = data.plans[pi];
      var chipList = Array.prototype.slice.call(chipsEl.querySelectorAll('[data-pb-plan-chip]'));
      chipList.sort(function (a, b) {
        var pa = byId[a.getAttribute('data-pb-plan-chip')], pb = byId[b.getAttribute('data-pb-plan-chip')];
        return (pa ? planDays(pa) : 0) - (pb ? planDays(pb) : 0);
      });
      for (var ci2 = 0; ci2 < chipList.length; ci2++) chipsEl.appendChild(chipList[ci2]);
    }

    /* Warenkorb: Paket und Pfand (eine Position je Paket) in einem Aufruf anlegen, im Abo beides mit
       demselben Verkaufsplan. Ersetzt den Ablauf von product-form.js, der nur eine Position kennt. */
    var pf = root.querySelector('[data-pb-form]');
    if (pf) {
      pf.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
        var sel = update.sel;
        if (!sel) return;
        var packLine = { id: sel.id, quantity: sel.q };
        if (sel.plan) packLine.selling_plan = sel.plan;
        if (sel.props) packLine.properties = sel.props;
        /* Pfand zuerst anlegen: Shopify zeigt die zuletzt angelegte Position oben, so steht das Paket ueber seinem Pfand */
        var items = [];
        var pfl = sel.cans > 0 ? pfandFor(sel.cans) : null;
        if (pfl) {
          var pfLine = { id: pfl.v.id, quantity: pfl.q * sel.q };
          if (sel.plan && pfl.v.sp && pfl.v.sp[sel.plan] != null) pfLine.selling_plan = sel.plan;
          items.push(pfLine);
        }
        items.push(packLine);
        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var body = { items: items };
        if (cart && cart.getSectionsToRender) {
          body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
          if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
        }
        var errWrap = pf.querySelector('.product-form__error-message-wrapper');
        var errMsg = pf.querySelector('.product-form__error-message');
        function showError(msg) { if (!errWrap) return; errWrap.hidden = !msg; if (errMsg) errMsg.textContent = msg || ''; }
        showError('');
        submit.setAttribute('aria-disabled', 'true');
        submit.classList.add('loading');
        var spin = submit.querySelector('.loading__spinner');
        if (spin) spin.classList.remove('hidden');
        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { showError(res.description || res.message || data.t.error); return; }
            if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: sel.id, cartData: res });
            }
            if (cart && cart.renderContents) cart.renderContents(res);
            else window.location = (window.routes && window.routes.cart_url) || '/cart';
          })
          .catch(function () { showError(data.t.error); })
          .finally(function () {
            submit.classList.remove('loading');
            submit.removeAttribute('aria-disabled');
            if (spin) spin.classList.add('hidden');
          });
      }, true);
    }

    /* Link mit ?abo=1 (z. B. vom Abo-Produkt): Abo vorwaehlen */
    if (aboRadio && !aboRadio.disabled && /[?&]abo=1(&|$)/.test(window.location.search)) aboRadio.checked = true;

    /* Startwerte des Wunschpakets: Paketgroesse der vorgewaehlten Kachel (sonst Einstellung), Sorte der Seite */
    if (mixer) {
      var preEl = checkedEl('[data-pb-pack]:not([data-pb-mix])');
      var preCans = preEl ? parseInt(preEl.value, 10) : parseInt(mixer.preCans, 10) || 0;
      mixInit(preCans);
      /* Probierpaket vorgewaehlt: Zusammenstellung nur merken, Kachel bleibt */
      if (!checkedEl('[data-pb-pack][data-pb-mix]')) syncSize();
    }

    /* Startbild: Das Set der Auswahl blendet update() ein (beim Laden schon von der Sektion gesetzt) */
    update();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-cw-pb]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);

  /* Theme-Editor: angeklicktes Aufklapp-Feld oeffnet sich */
  if (!window.__cwPbAccEditor) {
    window.__cwPbAccEditor = true;
    document.addEventListener('shopify:block:select', function (e) {
      var el = e.target;
      if (!el || !el.hasAttribute || !el.hasAttribute('data-pb-acc')) return;
      el.classList.add('is-open');
      var head = el.querySelector('[data-pb-acc-head]');
      if (head) head.setAttribute('aria-expanded', 'true');
    });
  }
})();
